import React, { useState } from 'react';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import MarkdownView from '../../components/common/MarkdownView';
import { Competition } from '../../types/interfaces';
import Timeline from './Timeline';

interface Props {
  competition: Competition;
  instructions: { loading: boolean; error: string; content: string };
}

const OverviewTab: React.FC<Props> = ({ competition, instructions }) => {
  const [expanded, setExpanded] = useState(false);
  return (
  <div className="competition-overview" data-tour="competition-overview">
    <section className="competition-card"><h2>About</h2><p>{competition.description}</p></section>
    {competition.submission && (
      <section className="competition-card"><h2>Submission format</h2><p>{competition.submission}</p></section>
    )}
    <section className="competition-card"><h2>Timeline</h2><Timeline startDate={competition.start_date} endDate={competition.end_date} /></section>
    {competition.instructions_path && (
      <section className="competition-card">
        <h2>Instructions</h2>
        {instructions.loading ? (
          <LoadingSpinner size="sm" text="Loading instructions..." />
        ) : instructions.error ? (
          <div className="markdown-error">
            <p>{instructions.error}</p>
            <p><a href={competition.instructions_path} target="_blank" rel="noopener noreferrer">Open the instructions in a new tab</a></p>
          </div>
        ) : (
          <div className="markdown-content">
            <div id="competition-readme" className={`markdown-container${expanded ? ' expanded' : ''}`}>
              <MarkdownView>{instructions.content}</MarkdownView>
            </div>
            <button type="button" className="btn-expand-markdown" aria-expanded={expanded} aria-controls="competition-readme"
              onClick={() => setExpanded((v) => !v)}>
              {expanded ? 'Collapse' : 'Expand'}
            </button>
          </div>
        )}
      </section>
    )}
  </div>
  );
};

export default OverviewTab;
